var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(-927 -96)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(927 96)",
    fill: "#ef6a20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-left-arrow-alt",
    transform: "translate(947.688 118.102) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_94",
    "data-name": "Trazado 94",
    d: "M14.63,18.651l-2.885-2.885h6.443V14.422H11.745l2.885-2.885-.95-.95L9.172,15.094,13.68,19.6Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.006accde08798141543a1a2343a1f4b6.svg";
export { ForwardRef as ReactComponent };